import { render, staticRenderFns } from "./des.vue?vue&type=template&id=4c42aa22&scoped=true"
import script from "./des.vue?vue&type=script&lang=js"
export * from "./des.vue?vue&type=script&lang=js"
import style0 from "./des.vue?vue&type=style&index=0&id=4c42aa22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42aa22",
  null
  
)

export default component.exports